export default "__VITE_ASSET__CK5zoVcE__"